import { AxiosError } from 'axios'

function hasSafeErrorStatus(error: AxiosError) {
  const safeStatus = error.response?.config.safeErrorStatus
  const responseStatus = error.response?.status

  return safeStatus && responseStatus && safeStatus.includes(responseStatus)
}

export { hasSafeErrorStatus }
